import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgClass } from '@angular/common';
import { Subscription } from 'rxjs';
import { User } from '@Models';
import { NavigationEnd, Router, RouterLinkWithHref } from '@angular/router';
import { AuthService } from '@Services';

@Component({
  selector: 'app-admin-navigation',
  standalone: true,
  imports: [RouterLinkWithHref, NgClass],
  templateUrl: './admin-navigation.component.html',
  styleUrl: './admin-navigation.component.css',
})
export class AdminNavigationComponent implements OnInit, OnDestroy {
  currentUrl: string | null = null;
  url: string | null = null;
  private routerSubscription: Subscription | null = null;

  user: User | null = null;

  constructor(
    private router: Router,
    private _authService: AuthService,
  ) {
    this._authService.user$.subscribe((user) => {
      this.user = user;
    });
  }

  ngOnInit(): void {
    this.currentUrl = this.router.url;
    this.url = this.removeLastPart(this.router.url);

    this.routerSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.updateUrls(event.urlAfterRedirects);
      }
    });
  }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  private updateUrls(url: string): void {
    this.currentUrl = url;
    this.url = this.removeLastPart(url);
  }

  private removeLastPart(url: string): string {
    const parts = url.split('/');
    if (parts.length > 2 && parts[parts.length - 2] === 'vaccinations') {
      parts.pop(); // Remove the last part
      parts.pop(); // Remove the second-to-last part
    } else {
      parts.pop(); // Remove the last part
    }
    return parts.join('/');
  }

  isUrlMatch(endpoints: string[]): boolean {
    if (!this.currentUrl) {
      return false;
    }
    const currentEndpoint = this.currentUrl.split('/').pop();
    return endpoints.includes(currentEndpoint || '');
  }

  removeFocus(event: Event): void {
    (event.target as HTMLElement).blur();
  }
}
